export default function formErrors(formState) {
  const errors = {};
  for (const fieldName of Object.keys(formState.errors)) {
    errors[fieldName] = formState.errors[fieldName].message;
  }
  return errors;
}
